document.addEventListener("DOMContentLoaded", function () {
  jQuery(".download_button_video").each(function (i, obj) {
    jQuery(this).on("click", function (e) {
      e.preventDefault;
      var videoID = jQuery(this).data("video-id");
      jQuery("#" + videoID).fadeIn();
      jQuery("body").addClass("video-active");
    });
  });

  jQuery(".download_button_video__close").on("click", function (e) {
    e.preventDefault;
    jQuery(".featured-download-video__wrapper").fadeOut();
    jQuery("body").removeClass("video-active");
    const iframe = jQuery(this).parent().find("iframe");
    if (iframe) {
      iframe.attr("src", iframe.attr("src"));
    }
  });
});
